function toggleClass(triggerClass, targetClass, className) {
	var elements = document.querySelectorAll(targetClass);
	var clickableItems = document.querySelectorAll(triggerClass);

	for ( var i = 0; i < clickableItems .length; i++ ) (function(i){ 
		clickableItems [i].onclick = function() {

			for (var e = 0; e < elements.length; e++ ) (function(e){
				elements [e].classList.toggle(className);
			})(e);
		}
	})(i);
}

//Search banner
toggleClass(".js-toggle-search-banner", "body", "body--search-banner-is-open");

//Nav bar mobile
toggleClass(".js-toggle-nav-bar-mobile", "body", "body--nav-bar-mobile-is-open");

//Nav subbar mobile
toggleClass(".js-toggle-nav-subbar-mobile", "body", "body--nav-subbar-mobile-is-open");

//Notification
toggleClass(".js-toggle-notification", ".notification", "notification--animate-out");

//Mobile share buttons
toggleClass(".js-toggle-mobile-share-buttons", ".share-buttons", "share-buttons--show-buttons");